import * as React from "react";
import { Checkbox, FormControl, FormHelperText, Grid } from "../widget";
import { RxFormField } from "../../rx-form";
import { isDefined } from "../../utils";
import KeyValuePair from "../../utils/KeyValuePair";
import { WithStyles, withStyles, createStyles, Theme } from '../mui/styles';


const styles = (theme: Theme) => createStyles({
});


export interface CheckBoxSelectionProps extends RxFormField
{
    autoFocus?: boolean;
    fullWidth?: boolean;
    items?: KeyValuePair<number | string, string>[];
    singleSelect?: boolean;
}

interface State
{
    checkedItems: Array<number | string>;
}

type PropsType = CheckBoxSelectionProps & WithStyles<typeof styles>;

class CheckBoxSelection extends React.Component<PropsType, State> {

    constructor(props: PropsType)
    {
        super(props);
        this.state = {
            checkedItems: props.value || [],
        }
    }

    handleChange = (k: KeyValuePair<number | string, string>) => (event: React.ChangeEvent<HTMLInputElement>) =>
    {
        const { singleSelect, ...field } = this.props;
        const isChecked = event.target.checked;
        this.setState(state =>
        {
            const checkedItems = singleSelect === true ? [] : state.checkedItems.concat([]);
            const index = checkedItems.indexOf(k.key);
            if (isChecked && index < 0) {
                checkedItems.push(k.key);
            } else if (index >= 0) {
                checkedItems.splice(index, 1);
            }
            field.setValue(checkedItems);
            return { checkedItems: checkedItems };
        });
    };

    getChecked = (k: KeyValuePair<number | string, string>) =>
    {
        const { ...field } = this.props;
        const checkedItems = field.value as Array<number | string> || [];
        return checkedItems.indexOf(k.key) >= 0;
    }

    render()
    {
        const { fullWidth, items, classes, ...field } = this.props;

        const helperTextId = (field.note || field.error) ? `${field.id}-text` : undefined;
        const hasError = field.touched && isDefined(field.error);
        const helperText = hasError ? field.error : field.note;


        return <FormControl fullWidth={fullWidth} error={hasError} aria-describedby={helperTextId}>
            <Grid container direction="column">
                {items.map((i, k) => <Grid key={i.key} item><Checkbox checked={this.getChecked(i)} onChange={this.handleChange(i)} value={i.key} /> {i.value}</Grid>)}
            </Grid>
            {helperText && <FormHelperText id={helperTextId}>{helperText}</FormHelperText>}
        </FormControl>;
    }
}

export default withStyles(styles)(CheckBoxSelection);
